import {forwardRef} from 'react'
import type {IconProps} from '../types'

export const XCircleIcon = forwardRef<SVGSVGElement, IconProps>(
  ({size = 20, color = 'currentColor', className, ...props}, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        id="Subtract"
        d="M12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5ZM15.3135 8.68652C14.8644 8.23742 14.1356 8.23742 13.6865 8.68652L12 10.373L10.3135 8.68652C9.86437 8.23742 9.13563 8.23742 8.68652 8.68652C8.23742 9.13563 8.23742 9.86437 8.68652 10.3135L10.373 12L8.68652 13.6865C8.23742 14.1356 8.23742 14.8644 8.68652 15.3135C9.13563 15.7626 9.86437 15.7626 10.3135 15.3135L12 13.627L13.6865 15.3135C14.1356 15.7626 14.8644 15.7626 15.3135 15.3135C15.7626 14.8644 15.7626 14.1356 15.3135 13.6865L13.627 12L15.3135 10.3135C15.7626 9.86437 15.7626 9.13563 15.3135 8.68652Z"
        fill={color}
      />
    </svg>
  ),
)

XCircleIcon.displayName = 'XCircleIcon'
